import EmptyComponent from 'src/components/atomic/Molecules/EmptyComponent'
import Span from 'src/components/atomic/atom/Span'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { RootState } from 'src/store/store'
import { COLOR } from 'src/constants/colors'
import { ExplorerDataPropsType } from 'src/views/Service/Explorer/Main'
import ExplorerMainFileCategory from 'src/components/atomic/organisms/views/Explorer/Main/ExplorerMainFileCategory'
import ExplorerMainFileStorage from 'src/components/atomic/organisms/views/Explorer/Main/ExplorerMainFileStorage'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import ExplorerMainDeleteNavBtn from 'src/components/atomic/organisms/views/Explorer/Main/ExplorerMainDeleteNavBtn'

const ExplorerMainTemplate = (props: { data: ExplorerDataPropsType }) => {
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { EmptyComponentStatus } = useAppSelector((state: RootState) => state.ExplorerPage)

  return (
    <>
      <Span option="title" $margin={setMediaStyle('33px 0 5px 0', '16px 0 8px 0', '16px 0 8px 0')}>
        {t('EXPLORER.TITLE', { defaultValue: 'Select the files need to back up in Explorer' })}
      </Span>
      <Span option="desc" color={COLOR.black70}>
        {t('EXPLORER.DESC', {
          defaultValue:
            'You can access the mobile phone and directly select the files you need to back up.',
        })}
      </Span>
      {EmptyComponentStatus !== 'default' ? (
        <EmptyComponent
          option={EmptyComponentStatus}
          button={true}
          $margin={setMediaStyle('187px auto 0 auto', '95px auto 0 auto', '95px auto 0 auto')}
        />
      ) : (
        <>
          <ExplorerMainFileCategory data={props.data} />
          <ExplorerMainFileStorage data={props.data} />
          <ExplorerMainDeleteNavBtn />
        </>
      )}
    </>
  )
}
export default ExplorerMainTemplate
